<template>
  <div>
    <el-form-item label="说明文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请输入说明文字" type="textarea"  :rows="4"  maxlength="250" show-word-limit/>
    </el-form-item>
    <!-- <el-form-item label="文字颜色">
      <el-color-picker v-model="value.color" size="medium"></el-color-picker>
    </el-form-item> -->
  </div>
</template>

<script>
export default {
  name: "Description",
  components: {},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
